import React from 'react'
import { Modal, ModalBody, ModalHeader, Table } from 'reactstrap'

const InfoTablePopUp = (props) => {

    return (
        <Modal className="total-bids" isOpen={props.showPopUpText} toggle={props.toggleInfoPopup} size={!props?.isMobile ? "lg" : "sm"}>
            <ModalHeader className='toggle mb-0' toggle={props.toggleInfoPopup}></ModalHeader>
            <ModalBody>
                <div className="header">Total Bids</div>
                <div className='wrapper'>
                    <Table className='bid-table'>
                        <tr className="table-header">
                            <th className='head'>Series</th>
                            <th className='head'>Tenure (months)</th>
                            <th className='head'>Yield</th>
                            <th className='head'>Interest Payout</th>
                            <th className='head'>Principal Repayment </th>
                            <th className='head'>Unit</th>
                            <th className='head'>Bid Amount</th>
                        </tr>
                        {props?.selectedItems.map((item) =>
                            <tr className='text-center bid-row' key={item.ISIN}>
                                <td className='data'>{item.productName}</td>
                                <td className='data'>
                                    {item.maxTenure}
                                </td>
                                <td className='data'>
                                    {item.xirr}%
                                </td>
                                <td className='data'>
                                    {item.couponType}
                                </td>
                                <td className='data'>
                                    {item.principalRepayment}
                                </td>
                                <td className='data'>
                                    {props?.inputValues[item.ISIN]}
                                </td>
                                <td className='data'>{props?.inputValues[item.ISIN] ? (item.faceValue * props?.inputValues[item.ISIN]).oroNumber(2, true) : "₹ 0"}</td>
                            </tr>
                        )
                        }
                    </Table>
                </div>
                <div className='d-flex justify-content-between mt-3 foot'>
                    <p className='mb-0 total'>Total Bid Amount</p>
                    <p className='mb-0 amount'><b>{(props?.totalAmount).oroNumber(2, true)}</b></p>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default InfoTablePopUp